import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import Navigation from 'flarum/common/components/Navigation';
import LinkButton from 'flarum/common/components/LinkButton';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import classList from 'flarum/common/utils/classList';
/**
 * Make the header back arrow deterministic when reading a post.
 *
 * Core's Navigation back button pops `app.history`; when the stack is empty (a
 * direct visit, or after any full page reload) it falls through to
 * `history.home()` — which, on a forum whose home is a custom Page Builder page,
 * is NOT the discussion list. The result was a back arrow that behaved
 * differently depending on how you arrived (and on the list layout you came
 * from), and in category layout it landed you on the Page Builder home.
 *
 * So: on a discussion page, regardless of history, the back arrow ALWAYS links
 * to the discussion-index route. `app.route('index')` is the IndexPage route,
 * whose path is `/all` in Flarum 2 — it resolves to `/all` when another page is
 * set as home (the live site) and to `/` when the index itself is home (dev).
 * Same destination — the all-discussions list — in every layout. Off discussion
 * pages, the default Navigation behaviour is untouched.
 */
export default function applyBackButton() {
  override(Navigation.prototype, 'view', function (original) {
    const onDiscussion = app.current && app.current.matches && app.current.matches(DiscussionPage);
    if (!onDiscussion) return original();
    const indexHref = app.route('index');
    const pane = app.pane;
    return m('div', {
      className: classList('Navigation ButtonGroup', this.attrs.className),
      onmouseenter: pane && pane.show.bind(pane),
      onmouseleave: pane && pane.onmouseleave.bind(pane)
    }, [m(LinkButton, {
      className: 'Button Navigation-back Button--icon',
      href: indexHref,
      icon: 'fas fa-chevron-left',
      'aria-label': app.translator.trans('core.forum.header.back_to_index_tooltip'),
      onclick: e => {
        if (e.shiftKey || e.ctrlKey || e.metaKey || e.which === 2) return;
        e.preventDefault();
        m.route.set(indexHref);
      }
    }),
    // Preserve the pane pin toggle when a pane is active.
    typeof this.getPaneButton === 'function' ? this.getPaneButton() : null]);
  });
}